import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { useMsal } from '@azure/msal-react';
import { AttentionMessage, Box, Button, Container } from '@tq/ui-components';

import { useIsMobile } from '@tq/ui-components/dist/hooks';

export const Home: React.FC = () => {
  const { t } = useTranslation('home');
  const isMobile = useIsMobile();
  const { instance } = useMsal();

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Box display='grid' gridGap={6}>
        <AttentionMessage
          status='info'
          description={t(
            'welcome_message',
            'Welcome to the Consultee Hub. You will need to log in to access your consultations.'
          )}
        />
        <Button
          onClick={async () => {
            await instance.loginRedirect({
              scopes: [process.env.REACT_APP_B2C_SCOPE || ''],
            });
          }}
          justifySelf='center'
          rightIcon={<FaExternalLinkAlt />}
          w={isMobile ? '100%' : 'inherit'}
        >
          {t('log_in', 'Log in')}
        </Button>
      </Box>
    </Container>
  );
};
